import React from "react";
import { Box } from "@mui/system";
import { AppBar, Button, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import PreservingLink from "../PreservingLink";
import { Person } from "@mui/icons-material";
import { logout } from "../LoginGuard/loginGuard";
import { getCodeSession } from "../../utils/session";

/** The header's height, declared on the Toolbar rather than left to emerge
 * from whatever the content happens to measure. */
const HEADER_HEIGHT = { xs: 72, md: 80 };


export default function Header(props: { logoutEnabled: boolean }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // An invitation session: the token carries `codeAssignment` and there is no
  // account behind it — no name, e-mail or picture to show. The generic avatar
  // would promise an account the person never created, so this session says in
  // words what it is instead.
  const codeSession = getCodeSession();

  return (
    <AppBar position="sticky">
      <Toolbar
        sx={{
          justifyContent: "space-between",
          gap: 2,
          minHeight: {
            xs: `${HEADER_HEIGHT.xs}px!important`,
            md: `${HEADER_HEIGHT.md}px!important`,
          },
        }}
      >
        <Box sx={{ display: "flex" }} component={PreservingLink} to="/" flexWrap="wrap">
          <Box
            component="img"
            src="/images/logo.png"
            alt="Catvante"
            sx={{
              maxHeight: {
                xs: 40,
                md: 40
              },
              filter: 'brightness(0) invert(1)',
            }}
          /> {/*remove bg color*/}
        </Box>
        {
          props.logoutEnabled &&
          <React.Fragment>
            <Box
              component={Button}
              px={codeSession ? { xs: 1.5, md: 2 } : { xs: 1, md: 1.25 }}
              py={codeSession ? 0 : { xs: 1, md: 1.25 }}
              sx={{
                display: "flex",
                minWidth: 0,
                bgcolor: "grey",
                ":hover": {
                  bgcolor: "darkgray"
                },
              }}
              flexWrap="wrap"
              onClick={(event) => handleClick(event)}
            >
              {
                codeSession
                  ? <Typography
                    variant="body2"
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.8125rem", md: "0.875rem" },
                    }}
                  >
                    Acesso por código
                  </Typography>
                  : <Person
                    sx={{
                      color: "white",
                      height: {
                        xs: 32,
                        md: 40
                      },
                      width: 'auto',
                    }}
                  />
              }
            </Box>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => logout({ expired: false })}>
                {codeSession ? "Sair" : "Logout"}
              </MenuItem>
            </Menu>
          </React.Fragment>
        }
      </Toolbar>
    </AppBar>
  );
}